/* =========================================================
   MARCZEN — RELOJ SINCRONIZADO CON RELEASIT COD
   ETAPA 1: 8 MINUTOS
   ETAPA 2: 5 MINUTOS
   INDEPENDIENTE POR PRODUCTO
   ========================================================= */

(function () {
  "use strict";

  const STAGE_1_SECONDS = 8 * 60;
  const STAGE_2_SECONDS = 5 * 60;
  const TOTAL_SECONDS = STAGE_1_SECONDS + STAGE_2_SECONDS;

  const FINAL_MESSAGE_MS = 3000;

  function getStorageKey() {
    let pageKey = window.location.pathname
      .replace(/\/+$/, "")
      .toLowerCase();

    if (!pageKey || pageKey === "/") {
      pageKey = "home";
    }

    pageKey = pageKey.replace(/[^a-z0-9_-]/g, "_");

    return "marczen_offer_session_" + pageKey;
  }

  function getEndTime() {
    try {
      const saved = Number(
        window.sessionStorage.getItem(getStorageKey())
      );

      if (Number.isFinite(saved) && saved > 0) {
        return saved;
      }
    } catch (error) {}

    return null;
  }

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    return (
      String(minutes).padStart(2, "0") +
      ":" +
      String(remainingSeconds).padStart(2, "0")
    );
  }

  // Evita reescribir textos que ya tienen el valor correcto.
  function setTextIfChanged(element, value) {
    if (element.textContent !== value) element.textContent = value;
  }

  // Reutiliza las referencias mientras el formulario siga conectado.
  // Si Releasit reemplaza el formulario, se vuelven a buscar.
  let cachedElements = null;
  function getClockElements() {
    if (cachedElements && Object.values(cachedElements).every(el => el && el.isConnected)) {
      return cachedElements;
    }
    cachedElements = {
      container: document.getElementById("mz-reloj-formulario"),
      title: document.getElementById("mz-reloj-titulo"),
      description: document.getElementById("mz-reloj-descripcion"),
      time: document.getElementById("mz-reloj-tiempo")
    };
    return cachedElements;
  }

  function updateFormClock() {
    const { container, title, description, time } = getClockElements();

    if (!container || !title || !description || !time) {
      return;
    }

    const endTime = getEndTime();

    if (!endTime) {
      setTextIfChanged(title, "⏰ PRECIO ESPECIAL ACTIVADO");
      setTextIfChanged(description, "Consultando tiempo restante");
      setTextIfChanged(time, "--:--");
      return;
    }

    const remainingTotal = Math.max(
      0,
      Math.ceil((endTime - Date.now()) / 1000)
    );

    if (remainingTotal > STAGE_2_SECONDS) {
      // ETAPA 1
      setTextIfChanged(title, "⏰ PRECIO ESPECIAL ACTIVADO");
      setTextIfChanged(description, "Tiempo restante de la oferta");

      setTextIfChanged(time, formatTime(
        remainingTotal - STAGE_2_SECONDS
      ));

    } else if (remainingTotal > 0) {
      // ETAPA 2
      setTextIfChanged(title, "🔥 ¡TIEMPO EXTRA!");
      setTextIfChanged(description, "Última oportunidad de la promoción");

      setTextIfChanged(time, formatTime(remainingTotal));

    } else {
      // FINALIZADO
      setTextIfChanged(title, "⏰ OFERTA FINALIZADA");
      setTextIfChanged(description, "Esta promoción ya terminó");
      setTextIfChanged(time, "00:00");
    }
  }

  function init() {
    updateFormClock();

    // Releasit puede insertar el formulario después de cargar la página.
    // Consultamos el mismo tiempo guardado cada segundo.
    window.setInterval(function () {
      if (!document.hidden) updateFormClock();
    }, 1000);
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) updateFormClock();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();